import { NgModule } from '@angular/core';
import { TooltipComponent } from './compoments/tooltip/tooltip.component';
import { MatIconModule } from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';

const materialModules = [
  MatIconModule,
];

@NgModule({
  imports: [
    SharedModule,
    TranslateModule.forChild(),
    ...materialModules
  ],
  declarations: [
    TooltipComponent,
  ],
  exports: [
    TooltipComponent,
  ]
})
export class TooltipModule { }
